<template lang="pug">
  v-dialog(v-model="show" max-width="500" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown")
    v-card.d-flex.flex-column(flat)
      v-card-title.headline {{ $t('settingsPage.offerStructure.newSubGroupLabel') }}
      v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body
        v-form(v-model="isFormValid" @submit.prevent="onSubmitButtonClick" ref="form" :disabled="loading" lazy-validation)
          v-row
            v-col(cols="12")
              v-text-field(outlined v-model="subgroupName" :label="$t('settingsPage.offerStructure.nameLabel')" :rules="nameRules" autofocus)
      v-divider
      v-card-actions
        v-spacer
        v-btn( color="primary" text @click="onCancelButtonClick" :disabled="loading" ) {{ $t('optOutDialog.cancelButtonLabel') }}
        v-btn(color="primary" type="submit" :loading="loading" @click="onSubmitButtonClick" :disabled="!isFormValid") {{$t('optOutDialog.submitCreditButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import i18n from "@/plugins/i18n";


@Component({})

export default class AddNewSubGroupDialog extends Vue {
  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean

  private isFormValid: boolean = false
  private subgroupName: string = ''
  private nameRules: Array<(v:string) => string | boolean> = [
    (v:string) => !!v || i18n.t('settingsPage.offerStructure.nameValidationText').toString()
  ]



  onSubmitButtonClick (): void {
    this.$emit('save', this.subgroupName)
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }

  mounted() {

  }

}

</script>

<style lang="stylus" scoped>

</style>
